import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";

/** Utilities */
import { setReports } from "../../app/slice/reportSlice";
import { getAuthProps } from "../../utils/authentication/authLibrary";

/** RTK Query */
import { useLazyGetDataQuery } from "../../app/services/commonApi";

/** Pages */
import UnauthorizedPage from "../unauthorizedPage/UnauthorizedPage";
import ApplicantReport from "../applicantReport/ApplicantReport";
import JobReports from "../jobReports/JobReports";
import ActivityLog from "../activityLog/ActivityLog";
import TalentCrmReport from "./TalentCrmReport";

const ReportAccess = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const reports = useSelector((state) => state.report?.reports || []);
  const authData = getAuthProps();

  const [loading, setLoading] = useState(true);
  const [getAllReports] = useLazyGetDataQuery();

  const normalizeReportName = (name) =>
    name?.replace(/^\/+/, "").trim().replace(/\s+/g, "-").toLowerCase();

  useEffect(() => {
    if (!reports.length) {
      getAllReports({ url: "/ReportPermission/GetAllReports" })
        .then((res) => {
          const mappedReports = res?.data?.data?.map((r) => ({
            ...r,
            roleIds: r.roleId ? r.roleId.split(",").map(Number) : [],
          })) || [];

          dispatch(setReports(mappedReports));
        })
        .catch((err) => {
          console.error("[ReportAccess] API error:", err);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }, [dispatch, getAllReports, reports.length]);

  if (loading) return <div>Loading...</div>;

  const currentPath = normalizeReportName(location.pathname);

  const currentReport = reports.find(
    (r) => normalizeReportName(r.reportName) === currentPath
  );

  if (!currentReport) return <UnauthorizedPage />;

  const userRoleId = Number(authData?.roleId || authData?.roles?.roleId);

  if (!currentReport.roleIds.includes(userRoleId)) {
    return <UnauthorizedPage />;
  }

  switch (currentPath) {
    case "candidate-report":
      return <ApplicantReport />;

    case "job-report":
      return <JobReports />;

    case "activity-log-report":
      return <ActivityLog />;

    case "talent-crm-report":
      return <TalentCrmReport />;

    default:
      return <UnauthorizedPage />;
  }
};

export default ReportAccess;